export default __webpack_public_path__ + "static/media/cancel.a5631ed6.svg";